import { getCmID } from './commonWidgetsJac'
import demoResume from './demoResume'
import demoPosventa from './demoPosventa'
import demoVenta from './demoVenta'
import demoKOX from './demoKOX'
import jacDuenosISD from './jacDuenosISD'
import jacDirectoresISD from './jacDirectoresISD'
import jacISD from './jacISD'
import demoFlotillas from './demoFlotillas'


export default {
    title: 'CXO Venta/Postventa Dashboard',
    description: 'Dashboard de CXO Venta/Postventa',
    backgroundClassName: (filters: any) => {
        /*return filters.criticalMoments.includes(getCmID('root'))
          ? 'default' : 'epsilon-hero-bg'*/
        return 'epsilon-hero-bg'
    },
    widgets: (filters: FiltersUI) => {
        //console.log('rendering widget para filtros')
        //console.log(filters)
        return [
            ...demoResume.widgets(filters).map((wdg) => ({
                ...wdg,
                render: (filters: FiltersUI) =>
                    filters !== undefined &&
                    filters.criticalMoments !== undefined &&
                    filters.criticalMoments !== null &&
                    (filters.criticalMoments.includes(getCmID('root')) ||
                        filters.criticalMoments.includes(getCmID('Retail'))),
            })),
            ...demoVenta.widgets(filters).map((wdg) => ({
                ...wdg,
                render: (filters: FiltersUI) =>
                    filters !== undefined &&
                    filters.criticalMoments !== undefined &&
                    filters.criticalMoments !== null &&
                    filters.criticalMoments.includes(getCmID('venta')),
            })),
            ...demoPosventa.widgets(filters).map((wdg) => ({
                ...wdg,
                render: (filters: FiltersUI) =>
                    filters !== undefined &&
                    filters.criticalMoments !== undefined &&
                    filters.criticalMoments !== null &&
                    (filters.criticalMoments.includes(getCmID('servicio')) ||
                        filters.criticalMoments.includes(getCmID('Postventa'))||
                        filters.criticalMoments.includes(getCmID('Garantias'))||
                        filters.criticalMoments.includes(getCmID('HyP'))
                    ),
            })),
            /*...jacDuenosISD.widgets(filters).map((wdg) => ({
                ...wdg,
                render: (filters: FiltersUI) =>
                    filters !== undefined &&
                    filters.criticalMoments !== undefined &&
                    filters.criticalMoments !== null &&
                    filters.criticalMoments.includes(getCmID('ISD')) &&
                    filters.logicalDistributions !== undefined &&
                    filters.logicalDistributions !== null &&
                    filters.logicalDistributions.includes(13609)
            })),
            ...jacDirectoresISD.widgets(filters).map((wdg) => ({
                ...wdg,
                render: (filters: FiltersUI) =>
                    filters !== undefined &&
                    filters.criticalMoments !== undefined &&
                    filters.criticalMoments !== null &&
                    filters.criticalMoments.includes(getCmID('ISD')) &&
                    filters.logicalDistributions !== undefined &&
                    filters.logicalDistributions !== null &&
                    filters.logicalDistributions.includes(13608)
            })),
            */
            ...demoKOX.widgets(filters).map((wdg) => ({
                ...wdg,
                render: (filters: FiltersUI) => {
                    const wdgRender = wdg?.render !== undefined
                        ? wdg?.render(filters) : true

                    return wdgRender &&
                        filters !== undefined &&
                        filters.criticalMoments !== undefined &&
                        filters.criticalMoments !== null &&
                        (
                            filters.criticalMoments.includes(getCmID('Usabilidad')) ||
                            filters.criticalMoments.includes(getCmID('koxDPC')) ||
                            filters.criticalMoments.includes(getCmID('koxDSC')) ||
                            filters.criticalMoments.includes(getCmID('koxEPC')) ||
                            filters.criticalMoments.includes(getCmID('koxESC')) ||
                            filters.criticalMoments.includes(getCmID('Dinamico')) ||
                            filters.criticalMoments.includes(getCmID('Estatico'))

                        )
                },
            })),
            ...jacISD.widgets(filters).map((wdg) => ({
                ...wdg,
                render: (filters: FiltersUI) =>
                    filters !== undefined &&
                    filters.criticalMoments !== undefined &&
                    filters.criticalMoments !== null &&
                    filters.criticalMoments.includes(getCmID('ISD'))
                //filters.logicalDistributions !== undefined &&
                //filters.logicalDistributions !== null &&
                //filters.logicalDistributions.includes(13608)
            })),
            ...demoFlotillas.widgets(filters).map((wdg) => ({
                            ...wdg,
                            render: (filters: FiltersUI) =>
                                filters !== undefined &&
                                filters.criticalMoments !== undefined &&
                                filters.criticalMoments !== null &&
                                (filters.criticalMoments.includes(getCmID('Flotillas'))
                            ),
            })),
        ]
    },
} as DasboardConfig
